<template>
  <v-container :fluid="true" class="page_container pt-0">
    <div class="promo__title">
      <span class="promo__title--text">
        Промокоды и акции
      </span>
      <span
          v-if="$vuetify.display.width > 960"
          class="promo__title--link"
          @click="navigateTo()"
      >
        Посмотреть все
        <v-icon size="12" class="ml-5">$custom_arrow_sm</v-icon>
      </span>
    </div>
    <div
      class="promo__content"
    >
      <PromocodeBlock
        v-if="!isLoading && promocodes.length > 0"
        :promocodes="promocodes"
      />
      <div v-else-if="!isLoading && promocodes.length === 0">
        <NoData
            :icon="'confirmation_number'"
            :text="'Следите за обновлениями.<br/> Уникальные промокоды уже в пути!'"
        />
      </div>
      <div v-else>
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
      <div
          v-if="$vuetify.display.width <= 960"
          class="promo__more"
          @click="navigateTo()"
      >
        посмотреть все
      </div>
    </div>

  </v-container>

</template>

<script>
import { defineComponent } from 'vue'
import PromocodeBlock from "@/modules/templates/PromocodeBlock.vue"
import pa_names from "@/modules/personal_account/routers/names"
import names from "@/modules/core/routers/names"
import { mapActions, mapGetters } from "vuex"
import { FulfillingSquareSpinner } from "epic-spinners"
import NoData from "@/modules/templates/NoData.vue"

export default defineComponent({
  name: "UserPromocodes",
  components: { NoData, PromocodeBlock, FulfillingSquareSpinner },
  data () {
    return {
      promocodes: [],
      isLoading: true,
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      items: 'personal_account/promocodes/getLazyPromocodes',
      isLoadingPromocodes: 'personal_account/promocodes/isLazyLoadingPromocodes',
    }),
  },
  methods: {
    ...mapActions({
      loadLazyPromocodes: 'personal_account/promocodes/loadLazyPromocodes',
    }),
    navigateTo () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: pa_names.PROMO.PAGE })
    },
    addCover (items) {
      for (let i = 0; i < items.length; i++) {
        this.promocodes.push({ ...items[i], cover: true })
      }
      this.isLoading = false
    },
    loadData (url = undefined) {
      this.loadLazyPromocodes({
        url: url,
        finalizer: (data) => {
          this.addCover(data)
        },
        catcher: () => {}
      })
    },
  },
  created () {
    this.loadData()
  }
})
</script>

<style scoped lang="scss">
.promo__title {
  display: flex;
  justify-content: space-between;
}

.promo__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.promo__title--link {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  height: 30px;
  font-size: 14px;
  line-height: 17px;
  color: #3254B9;
  cursor: pointer;
}

.promo__content {
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
}

.promo__more {
  content: "";
  display: inline-flex;
  position: absolute;
  left: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  width: 152px;
  height: 30px;
  background-color: #376FFE;
  border-radius: 0 5px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}

@media screen and (max-width: 960px) {
  .promo__content {
    padding: 50px;
    position: relative;
  }
}

@media screen and (max-width: 768px) {
  .promo__content {
    padding: 20px;
  }

  .promo__title {
    margin-top: 20px;
  }

  .promo__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }

  .promo__title--link {
    align-items: start;
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
